import { render, staticRenderFns } from "./PackingTaskCard.vue?vue&type=template&id=982ed472&scoped=true&"
import script from "./PackingTaskCard.vue?vue&type=script&lang=js&"
export * from "./PackingTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./PackingTaskCard.vue?vue&type=style&index=0&id=982ed472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982ed472",
  null
  
)

export default component.exports